import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import "./Dashboard.css";

function Dashboard({ onLogout }) {
  const [transactions, setTransactions] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // ✅ Static fallback data
    const demoData = [
      {
        wallet: "4Yl6MtxsYv8iHn...Hn2b",
        signature: "5D8LgHqzNmgGhZJ9TAVZFxJXUY4e5...",
        status: "Success",
        slot: 145678,
        fee: 5000,
        time: 1701783452,
      },
      {
        wallet: "9Jk4e8Fx5Gt9iUY...qF7t",
        signature: "9BhZkx39MTzPMxFdJZWU3nxtUSVaQ...",
        status: "Failed",
        slot: 145670,
        fee: 5000,
        time: 1701781502,
      },
      {
        wallet: "FZ65LhNwvz7Gr3h...Kx9s",
        signature: "2PZrb5a7XGr9cdmV9g6kFjtwAqrF...",
        status: "Success",
        slot: 145660,
        fee: 5000,
        time: 1701770000,
      },
    ];

    // ✅ API fetch
    axios
      .get("https://digitaleranetwork.naxbazar.in/api/get_transactions")
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : demoData;
        setTransactions(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setTransactions(demoData); // fallback
        setLoading(false);
      });
  }, []);

  const logout = () => {
    localStorage.removeItem("admin");
    if (onLogout) onLogout();
    navigate("/");
  };

  const filtered = transactions.filter((tx) =>
    tx.wallet?.toLowerCase().includes(search.toLowerCase()) ||
    tx.signature?.toLowerCase().includes(search.toLowerCase())
  );

  const successCount = transactions.filter((tx) => tx.status === "Success").length;
  const failedCount = transactions.filter((tx) => tx.status === "Failed").length;

  return (
    <div className="dashboard">
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="logo">⚡ AdminPanel</div>
        <nav>
          <ul>
            <li><Link to="/dashboard">📊 Transactions</Link></li>
            <li><Link to="/export">📥 Exports</Link></li>
            <li><Link to="/help">📚 Help</Link></li>
            {/* <li><Link to="/settings">⚙️ Settings</Link></li> */}
          </ul>
        </nav>
      </aside>

      {/* Main */}
      <main className="main">
        <header className="topbar">
          <h1>Transaction History</h1>
          <button onClick={logout} className="logout-btn">Logout</button>
        </header>

        {/* Stats Section */}
        <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
          <div style={{ padding: "12px 18px", background: "#e0f7e9", borderRadius: "10px" }}>
            ✅ Success: <strong>{successCount}</strong>
          </div>
          <div style={{ padding: "12px 18px", background: "#ffe4e6", borderRadius: "10px" }}>
            ❌ Failed: <strong>{failedCount}</strong>
          </div>
          <div style={{ padding: "12px 18px", background: "#e2e8f0", borderRadius: "10px" }}>
            📦 Total: <strong>{transactions.length}</strong>
          </div>
        </div>

        {/* Search */}
        <div className="search-bar">
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="🔍 Search wallet or signature"
          />
        </div>

        {/* Table */}
        <div className="table-wrapper">
          {loading ? (
            <p>Loading transactions...</p>
          ) : filtered.length === 0 ? (
            <p>No transactions found.</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Wallet</th>
                  <th>Signature</th>
                  <th>Status</th>
                  <th>Slot</th>
                  <th>Fee</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((tx, i) => (
                  <tr key={i}>
                    <td>{tx.wallet}</td>
                    <td className="signature">{tx.signature}</td>
                    <td>
                      <span className={`badge ${tx.status === "Success" ? "success" : "failed"}`}>
                        {tx.status}
                      </span>
                    </td>
                    <td>{tx.slot}</td>
                    <td>{tx.fee}</td>
                    <td>{new Date(tx.time * 1000).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </main>
    </div>
  );
}

export default Dashboard;
